import { isEqual } from "lodash";

export function compare(value1: unknown, value2: unknown, deep = false) {
  return deep ? isEqual(value1, value2) : value1 === value2
}

export default {
  compare
}
